import { post } from "../../helpers/api";
import { showToast as toast } from "../../components/Modals/toast";
import { i18n } from "../../main"; // Adjust the import path accordingly
import { filterItemsPosList } from "../../utils/filterItemsPos";

const state = {
  items: [],
  isLoadingData: true,
  isBtnLoading: false,
  isBtnEditLoading: false,
  search: "",
  isShowResultDialog: false,
  resultMsg: "",
  isSuccess: false,
  itemsPOS: [],
  searchPos: "",
  ca_id: "",
};

const mutations = {
  SET_IS_BTN_LOADING(state, isBtnLoading) {
    state.isBtnLoading = isBtnLoading;
  },
  SET_IS_LOADING_DATA(state, isLoadingData) {
    state.isLoadingData = isLoadingData;
  },

  REMOVE_ITEM(state, id) {
    state.items = state.items.filter((item) => {
      return item.i_id !== id;
    });
  },

  SET_SEARCH_POS(state, search) {
    state.searchPos = search;
  },
  SET_DELETE_SUCCESS(state, value) {
    state.isShowResultDialog = value.state;
    state.resultMsg = value.msg;
    state.isSuccess = value.isSuccess;
  },

  SET_ITEMS_POS(state, itemsPOS) {
    state.itemsPOS = itemsPOS;

  },
};

const actions = {
  async getItemsPOS({ commit }, payload) {
    try {
      post("item/get-items-purchase", payload)
        .then((response) => {
          commit("SET_ITEMS_POS", response.data);
          commit("SET_IS_BTN_LOADING", false);
          commit("SET_IS_BTN_EDIT_LOADING", false);
          commit("SET_IS_LOADING_DATA", false);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  },
  async addNewItem({ commit }, payload) {
    return post("returns-suplier/store", payload, {
      id: 18,
      action: "add",
    })
      .then((response) => {
        const t = i18n.global.t;

        toast("success", t("added_successfully"));
        return response;
      })
      .catch((error) => {
        commit("SET_IS_BTN_LOADING", false);
        const t = i18n.global.t;

        console.log(error);
        if (error.response.status == 408) {
          //you don't have permission to add new item message in toast
          toast("error", t("you_dont_have_permission_to_do_this_action"));
          return error;
        }
        //check error status code
        if (error.response.status === 505) {
          toast("error", t("you_didnt_buy_this_item_from_this_suplier_before"));
          return error;
        }
        //Item quantity in storage is less than returned item to suplier
        if (
          error.response.data.message.includes(
            "Item quantity in storage is less than returned item to suplier"
          )
        ) {
          toast("error", t("item_quantity_less_than_returned_item_to_suplier"));
        } else {
          toast("error", t("something_wrong"));
        }
        console.log(error);
        return error;
      });
  },
};

const getters = {
  filterItemsPOS(state) {
    return filterItemsPosList(state.itemsPOS, {
      ca_id: state.ca_id,
      searchPos: state.searchPos,
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
